export const rulesInitialState = {
    loading: false,
    data: [],
    error: '',
};
